import React, {useContext, useState} from "react";
import { Link } from "react-router-dom";
import { UserContext } from "../context/userContext";
import { postData } from "../fetchRoutes/postData";

 
export default function NavigationProp() {

    const logoutUrl = process.env.REACT_APP_LOGOUT_USER;

    const {isLoggedIn, setIsLoggedIn, userDetails, setUserDetails} = useContext(UserContext);

    const [isLoading, setIsLoading] = useState(false);


    // Handle logout
    const handleLogout = async () => {
        setIsLoading(true)
        try {
            const response = await postData(logoutUrl, userDetails);

            if (response.status === 'success') {
                setTimeout(() => {
                    setIsLoggedIn(false);
                    setUserDetails({
                        name: '',
                        email: '',
                        username:'',
                        role: ''
                    })
                }, 500);

        
            }
        } catch (err) {
            console.error('Error checking auth:', err);
            alert('An error occurred. Please try again later.');
        }finally{
            setIsLoading(false);
        }
    };

    // Dynamically determine the dashboard link based on the user role
    const getDashboardLink = () => {
        if (userDetails.role === 'buyer') return '/buyer/dashboard';
        if (userDetails.role === 'admin') return '/admin/dashboard';
        if (userDetails.role === 'seller') return '/seller/dashboard';
        return '#'; // default fallback in case the role is missing
    };

    return(
        <div className="navigation">
            {isLoading ? ( 
                    <div className="loaderContainer">
                        <div className="loader"></div>
                        <p className="loadingText">Logging out...</p>
                    </div>
                ):(

                    <ul>
                    <Link to={'/'} className="navLink">
                        <li className="link">Home</li>
                    </Link>

                    <Link to={'/properties'} className="navLink" >
                        <li className="link">Properties</li>
                    </Link>

                    <Link to={'/auctions'} className="navLink" >
                        <li className="link">Auctions</li>
                    </Link>

                    {/* If the user is logged in show the logout button otherwise show the login button */}
                    {isLoggedIn ? (
                        <>
                            <Link to={getDashboardLink()} className="navLink">

                                <li className="link">
                                    <div className="linkLogin username">
                                        <span className="userIcon"></span>
                                        <span className="login">{userDetails.name ? userDetails.name.split(" ")[0] : ""}</span>
                                    </div>
                                    
                                </li>
                            </Link>

                            <Link to={'/'} className="navLink" onClick={handleLogout} >
                                <li> 
                                    <div className="linkLogin">
                                        <span className="userIcon logoutIcon"></span>
                                        <span className="login">Logout</span>
                                    </div>
                                </li>
                            </Link>
                        </>
                    ):(
                        <Link to={'/account/login'} className="navLink" >
                            <li> 
                                <div className="linkLogin">
                                    <span className="userIcon"></span>
                                    <span className="login">Log In</span>
                                </div>
                            </li>
                        </Link>

                    )}
                        
                    </ul>
                )
            }

            
        </div>

    );

}